module.exports = __webpack_public_path__ + "static/media/facilidad.488f8efb.webp";